import * as React from 'react';

import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

export const InvalidMappingsWarning: React.VFC<{
  fileUploadsById: Record<string, ProjectFileUpload>;
  virtualGraphsById: Record<string, ProjectVirtualGraph>;
  mappingsByResource: Record<string, Mapping[]>;
}> = ({ fileUploadsById, virtualGraphsById, mappingsByResource }) => (
  <>
    <p>{copy.components.invalidMappings.dialog.message}</p>
    {Object.entries(mappingsByResource).map(([resourceId, mappings]) => (
      <div key={resourceId} className="sd-dialog-invalid-mappings__file">
        {fileUploadsById[resourceId]?.name ||
          virtualGraphsById[resourceId]?.name ||
          resourceId}
        <ul>
          {mappings.map((mapping) => (
            <li key={mapping.text}>{mapping.text}</li>
          ))}
        </ul>
      </div>
    ))}
  </>
);
